"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left6"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right6"));
var _filePdf = _interopRequireDefault(require("cccisd-icons/file-pdf"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _config = require("../config.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Header = function Header(props) {
  var prevMetricId = props.prevMetricId,
    nextMetricId = props.nextMetricId,
    setCurrentMetricId = props.setCurrentMetricId,
    saveQueryButton = props.saveQueryButton,
    renderVizReport = props.renderVizReport,
    metrics = props.metrics;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].header
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default",
    disabled: !prevMetricId,
    onClick: function onClick() {
      return setCurrentMetricId(prevMetricId);
    }
  }, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], {
    spaceRight: true
  }), "Previous Metric"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-info"
    }, /*#__PURE__*/_react["default"].createElement(_filePdf["default"], {
      spaceRight: true
    }), "PDF"),
    title: metrics.length > _config.REPORT_METRICS_LIMIT ? "NOTE: PDF capped at ".concat(_config.REPORT_METRICS_LIMIT, " pages") : 'Preview',
    render: function render() {
      return renderVizReport();
    }
  }), saveQueryButton), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default",
    disabled: !nextMetricId,
    onClick: function onClick() {
      return setCurrentMetricId(nextMetricId);
    }
  }, "Next Metric", /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
    spaceLeft: true
  })));
};
Header.propTypes = {
  prevMetricId: _propTypes["default"].number,
  nextMetricId: _propTypes["default"].number,
  setCurrentMetricId: _propTypes["default"].func,
  saveQueryButton: _propTypes["default"].node,
  renderVizReport: _propTypes["default"].func,
  metrics: _propTypes["default"].array
};
var _default = Header;
exports["default"] = _default;